import style from './InputError.module.scss'

const InputError = ({ error }) => {
  return error && (
    <span className={style['input-error']}>{error.message}</span>
  )
}

export default InputError;